import { gql } from "@apollo/client";

const fragments = {
  query: gql`
    fragment UserQuery on User {
      id
      firstName
      lastName
      employeeId
      itAdmin
      organisationName
      phoneNumber
      mobileNumber
      email
      notificationEmails
      namedRoles
      status
      name
      formattedLastSignIn
      contractIds
      contracts
      userToEnter
    }
  `
};

export default fragments;
